<div
  class="searchable-single-select"
  [class.searchable-single-select--open]="isOpen"
>
  <button
    type="button"
    class="trigger"
    (click)="toggleOpen()"
    [disabled]="disabled"
  >
    <span class="trigger__leading">
      <i-tabler name="search" class="trigger__icon"></i-tabler>
      <span class="trigger__label">{{ triggerLabel }}</span>
    </span>
    <i-tabler
      name="chevron-down"
      class="trigger__icon trigger__icon--end"
    ></i-tabler>
  </button>

  <div class="panel" *ngIf="isOpen">
    <div class="panel__search">
      <i-tabler name="search" class="panel__search-icon"></i-tabler>
      <input
        #searchInput
        type="text"
        [(ngModel)]="searchTerm"
        [placeholder]="searchPlaceholder"
        (keydown.enter)="selectOnlyFilteredOptionFromKeyboard($event)"
      />
    </div>

    <div class="panel__section-title" *ngIf="showSectionTitle">
      {{ sectionTitle }}
    </div>

    <div class="panel__options" *ngIf="filteredOptions.length; else emptyOptions">
      <button
        type="button"
        class="option"
        *ngFor="let option of filteredOptions"
        [class.option--selected]="isSelected(option.value)"
        (pointerdown)="selectValueFromPointer(option.value, $event)"
        (click)="selectValueFromClick(option.value, $event)"
      >
        <span class="option__marker">
          <i-tabler
            *ngIf="isSelected(option.value)"
            name="check"
            class="option__check"
          ></i-tabler>
        </span>
        <span class="option__label">{{ option.label }}</span>
      </button>
    </div>

    <ng-template #emptyOptions>
      <div class="panel__empty">{{ emptyMessage }}</div>
    </ng-template>

    <div class="panel__footer">
      <span>{{ footerLabel }}</span>
      <button
        *ngIf="clearable"
        type="button"
        class="panel__clear"
        (pointerdown)="clearSelectionFromPointer($event)"
        (click)="clearSelectionFromClick($event)"
        [disabled]="!selectedValue"
      >
        {{ clearLabel }}
      </button>
    </div>
  </div>
</div>
